import { render, staticRenderFns } from "./veSbzcZcPurchase.vue?vue&type=template&id=50ba12f0&scoped=true"
import script from "./veSbzcZcPurchase.vue?vue&type=script&lang=js"
export * from "./veSbzcZcPurchase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ba12f0",
  null
  
)

export default component.exports